"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevelopmentProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const types_1 = require("../types");
const components_1 = require("../../loaders/components");
const DevelopmentProviders = ({ children, loginComponent, drAgentLoginComponent, routerType = types_1.RouterType.BrowserRouter, }) => {
    const routes = ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/login", component: loginComponent }, "login"), drAgentLoginComponent && (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/dr-agent-login", component: drAgentLoginComponent }, "dr-agent-login"), children] }));
    return (0, jsx_runtime_1.jsx)(components_1.RouterWrapper, { routerType: routerType, children: routes });
};
exports.DevelopmentProviders = DevelopmentProviders;
//# sourceMappingURL=providers.js.map